import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { dataContext } from "../../App";
import activityLogSubmission from "../../helper/activitylog";
import styles from "./Campaign3.module.css";
import LoginDivOnly from "../../components/LoginDivOnly/LoginDivOnly";
import TCModalTournament from "../../components/Modal/TCModalTournament/TCModalTournament";
import OtpModal from "../../components/Modal/OtpModal/OtpModal";
import PaymentLoadingModal from "../../components/Modal/PaymentLoadingModal/PaymentLoadingModal";
const Campaign3 = ({subscriptionType,campaignPageNumber,bannerImgSrc,loginPlacement="center"}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeBottom, setActiveBottom] = useState("campaign");
  const [showLoginModalCampaign, setShowLoginModalCampaign] = useState(loginPlacement === "bottom");
  const [showTCModalTournament, setShowTCModalTournament] = useState(false);
  const [showPaymentLoadingModal, setShowPaymentLoadingModal] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [toggleToUpdate, setToggleToUpdate] = useState(false);
  const cid = searchParams.get("qcid");
  const {playerData} = useContext(dataContext);
  let navigate = useNavigate();
  if (!cid) {
    navigate("../");
  }
  useEffect(() => {
    let campaignId = null;
    if(searchParams.get('qcid')){
      sessionStorage.setItem('cid', searchParams.get('qcid'));
      campaignId = searchParams.get('qcid');
    }
    if (loginPlacement !== "bottom") {
      setTimeout(() => {
        setShowLoginModalCampaign(true);
      }, 3000);
    }

    let msisdn = null;
    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("campaign", msisdn);
    activityLogSubmission(`campaign${campaignPageNumber}`, msisdn);
  }, []);

  if (loginPlacement === "bottom") {
    return (
      <>
        <div className={styles.landingPageOuter}>
          <div className={styles.landingWrapper}>
            <img src={bannerImgSrc} alt="" className={styles.landingImgResponsive} />
            <div className={styles.loginOverlay}>
              {showLoginModalCampaign && <LoginDivOnly
                activeBottom={activeBottom}
                setActiveBottom={setActiveBottom}
                setShowLoginModalCampaign={setShowLoginModalCampaign}
                setShowOtpModal={setShowOtpModal}
                showOtpModal={showOtpModal}
                setShowTCModalTournament={setShowTCModalTournament}
                subscriptionType={subscriptionType}
                placement="bottom"
              ></LoginDivOnly>}
            </div>
          </div>
        </div>
        {showOtpModal && <OtpModal
          activeBottom={activeBottom}
          showOtpModal={showOtpModal}
          setShowPaymentLoadingModal={setShowPaymentLoadingModal}
          setShowOtpModal={setShowOtpModal}
        ></OtpModal>}
        {showPaymentLoadingModal && <PaymentLoadingModal
          showPaymentLoadingModal={showPaymentLoadingModal}
          setShowPaymentLoadingModal={setShowPaymentLoadingModal}
          activeBottom={activeBottom}
          toggleToUpdate={toggleToUpdate}
          setToggleToUpdate={setToggleToUpdate}
        ></PaymentLoadingModal>}
      </>
    );
  }

  return (
    <>
      <div className={`${styles.landingPage}`}>
        <img src={bannerImgSrc} alt="" srcSet="" className={styles.landingImg} onClick={()=>{
          setShowLoginModalCampaign(true)
        }} />
        {showLoginModalCampaign && <LoginDivOnly
          activeBottom={activeBottom}
          setActiveBottom={setActiveBottom}
          setShowLoginModalCampaign={setShowLoginModalCampaign}
          setShowOtpModal={setShowOtpModal}
          showOtpModal={showOtpModal}
          setShowTCModalTournament={setShowTCModalTournament}
          subscriptionType={subscriptionType}
        ></LoginDivOnly>}
        {showOtpModal && <OtpModal
          activeBottom={activeBottom}
          showOtpModal={showOtpModal}
          setShowPaymentLoadingModal={setShowPaymentLoadingModal}
          setShowOtpModal={setShowOtpModal}
        ></OtpModal>}
        {showPaymentLoadingModal && <PaymentLoadingModal
          showPaymentLoadingModal={showPaymentLoadingModal}
          setShowPaymentLoadingModal={setShowPaymentLoadingModal}
          activeBottom={activeBottom}
          toggleToUpdate={toggleToUpdate}
          setToggleToUpdate={setToggleToUpdate}
        ></PaymentLoadingModal>}
      </div>
    </>
  );
};

export default Campaign3;
